import React from 'react';
import {
  Box,
  Divider,
  createStyles,
  makeStyles,
  Theme,
} from '@material-ui/core';
import { Action, BaseActionsMenu } from '../../Dropdowns';
import * as Colors from '../../../theme/colors';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    separator: {
      margin: theme.spacing(0, 2),
      height: 22,
    },
    tableActionBox: {
      marginLeft: theme.spacing(1),
    },
    actionBox: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    menuItemActive: {
      backgroundColor: Colors.HoverNonBorderBackground,
    },
  }),
);

interface PageToolbarActionProps {
  actions: Action[];
  createButton?: React.ReactNode;
  onActionButtonAnchorElSet?: (element: HTMLElement | null) => void;
  isActive?: boolean;
}

export const PageToolbarAction: React.FC<PageToolbarActionProps> = ({
  actions,
  children,
  createButton,
  onActionButtonAnchorElSet,
  isActive = false,
}) => {
  const classes = useStyles();

  return (
    <Box className={classes.actionBox} width="180">
      <Box className={classes.actionBox}>
        <div className={isActive ? classes.menuItemActive : ''}>{children}</div>
        {actions.length > 0 && (
          <Box className={classes.tableActionBox}>
            <BaseActionsMenu
              parentComponentType="toolbar"
              actions={actions}
              onActionButtonAnchorElSet={onActionButtonAnchorElSet}
            />
          </Box>
        )}
        {createButton && actions.length > 0 && (
          <Divider orientation="vertical" className={classes.separator} />
        )}
      </Box>
      {createButton}
    </Box>
  );
};
